import React from "react";
import UTILS from "../../utils/commons";
import avatar from "../../img/no_data.svg";
import { Eye, Pen, Trash } from "lucide-react";

const CustomerItem = ( props ) => {

    var p = props.data;
    return (
        <div className={`grid md:grid-cols-5 gap-2 p-3 items-center border-t border-gray-100 hover:bg-gray-50 transition-colors ${props.className}`}>
            <div className="font-medium text-gray-800">
                <a className="hover:underline" href={`/customers/view/${p.id}`}>{p.name}</a>
            </div>
            <div className="text-gray-600">{p.phone}</div>
            <div className="text-gray-600 truncate" title={p.address}>{p.address}</div>
            <div className="text-gray-600">{p.region}</div>
            <div className="action-buttons flex items-center justify-center gap-2">
                <button className="p-1.5 rounded-md border border-gray-200 hover:border-primary-300 hover:text-primary-600" aria-label="View customer"><Eye className="h-4 w-4" onClick={( id ) => props.onClick( id )} /></button>
                {props.canEdit ? <button className="p-1.5 rounded-md border border-gray-200 hover:border-primary-300 hover:text-primary-600" aria-label="Edit customer"><Pen className="h-4 w-4" onClick={( id ) => props.onEdit( id )} /></button> : null}
                {/* <button><Trash className="hover:text-red-500" onClick={(id)=>props.onDelete(id)} /></button> */}
            </div>
        </div>
    )
}
export default CustomerItem;
